export default __webpack_public_path__ + "static/bell-active-1191e0cde5de91f0e0a67421411bca46.png";